import { Loader2, Sparkles } from 'lucide-react';

export const LoadingIndicator = () => {
  return (
    <div className="flex items-center gap-3 px-4 py-3">
      <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-primary/20 to-primary/10 flex items-center justify-center relative overflow-hidden">
        <Loader2 className="w-4 h-4 animate-spin text-primary relative z-10" />
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/20 to-transparent animate-shimmer" />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-foreground">AI is analyzing</span>
          <Sparkles className="w-3 h-3 text-primary animate-pulse" />
        </div>
        <div className="flex items-center gap-1">
          <span className="text-xs text-muted-foreground">Processing your request</span>
          <span className="animate-pulse">.</span>
          <span className="animate-pulse" style={{ animationDelay: '0.2s' }}>.</span>
          <span className="animate-pulse" style={{ animationDelay: '0.4s' }}>.</span>
        </div>
      </div>
    </div>
  );
};
